var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-overlay',{attrs:{"show":_vm.isLoading}},[_c('video-js',{staticClass:"embed-responsive embed-responsive-16by9",attrs:{"id":_vm.brightcovePlayerId,"data-account":this.accountId,"data-player":this.playerId,"data-video-id":this.videoId,"data-embed":"default","controls":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }